import env from './env';

export const CONFIG_CONSTANTS = {
    DEFAULT_LIMIT: 1000,
    API_HOST_PATH: env.REACT_APP_HOST_PATH,
    GOOGLE_GTAG_KEY: env.REACT_APP_G_TAG,
    SHOW_PHASE2_ALERT: env.REACT_APP_SHOW_PHASE2_ALERT?.toLowerCase() === 'true' ? true : false,
    ARCHIVE_URL: env.REACT_APP_ARCHIVE_URL as string | undefined
}